import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import Conversation from './conversation';

function MessengerConversation(props) {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.appContainer)}>
        <Conversation
          id={props.match.params.conversationId}
          onBackClick={() => {
            // navigate to /inbox
            props.history.push('/inbox');
          }}
          history={props.history}
        />
      </div>
    </div>
  );
}

MessengerConversation.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      conversationId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 75,
    [Theme.mobile_query]: {
      paddingTop: 0,
    },
  },
  appContainer: {
    // padding: '0 50px',
    margin: '-44px 0px -30px',
    [Theme.mobile_query]: {
      margin: 0,
    },
  },
  more_icon: {
    display: 'block',
    marginBottom: 21,

    ':not(.a) > svg > g': {
      transition: 'all 300ms',
    },
  },
  more: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 262,
    minWidth: 262,
    padding: '100px 18px',
    margin: '0 15px 23px',
    backgroundColor: '#f2f2f2',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#e8e8e8',
    fontSize: 15,
    color: '#39b4d6',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.3,
    transition: 'all 300ms',
    cursor: 'pointer',

    ':hover': {
      color: Theme.white,
      backgroundColor: '#39b4d6',
    },

    ':hover > .isvg > svg > g': {
      fill: Theme.white,
    },

    [Theme.mobile_query]: {
      width: '100%',
    },

    '@media screen and (min-width: 625px) and (max-width: 768px)': {
      width: 262,
    },
  },
  actions: {
    margin: '0 -5px',

    '@media screen and (max-width: 1170px)': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  sort: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    marginBottom: 30,
  },
  sort_select: {
    padding: 0,
    marginBottom: 0,
    marginLeft: 14,
    width: 135,
  },
  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -15px -15px',

    [Theme.mobile_query]: {
      padding: '0 20px',
    },

    '@media screen and (max-width: 1170px)': {
      justifyContent: 'center',
    },
  },
  heading: {
    marginBottom: 60,
    textAlign: 'center',
    fontSize: 45,
    lineHeight: 2.09,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  title: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  sub_heading: {
    position: 'relative',
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 400,
    fontSize: 18,
    color: '#000e1f',
    textAlign: 'center',
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessengerConversation));



// WEBPACK FOOTER //
// ./src/views/MessengerConversation/index.js